export default {
  // -----------------------------------------------------  Loaded data registry
  // <resourceName> : <Collection> -or- <model_object>
  dataRegistry: {
    // -------------------------------------------------------- Admin/Dispatcher
    // <Collection> --> the loaded provider connections for the active org
    providerConnections: null,

    // <Collection> --> the loaded routes
    routes: null,

    // <Collection> --> the loaded vehicles
    vehicles: null,

    // <Collection> --> the loaded drivers (objects are Users)
    drivers: null,

    // ------------------------------------------------------------------ Driver
    // <Route> --> the active delivery (route)
    activeDelivery: null,

    // <Collection> --> the loaded routes for the active driver
    myDeliveries: null
  },

  // ----------------------------------------------------- Item editing registry
  // <resourceName>: {
  //   originRoute: <route_object>,             --> the route that initiated the edit
  //   itemEditing: <model_object>,             --> the active model being edited
  //   itemEditing_messages: [<AppMessage>],    --> the queue of messages for this item
  //   itemEditing_activeMessage: <AppMessage>, --> the active message to be handled
  // },
  editingRegistry: {
    // -------------------------------------------------------- Admin/Dispatcher
    providerConnection: {
      originRoute: null,
      itemEditing: null,
      itemEditing_messages: [],
      itemEditing_activeMessage: null
    },
    route: {
      originRoute: null,
      itemEditing: null,
      itemEditing_messages: [],
      itemEditing_activeMessage: null
    },
    shipper: {
      originRoute: null,
      itemEditing: null,
      itemEditing_messages: [],
      itemEditing_activeMessage: null
    },
    receiver: {
      originRoute: null,
      itemEditing: null,
      itemEditing_messages: [],
      itemEditing_activeMessage: null
    },
    vehicle: {
      originRoute: null,
      itemEditing: null,
      itemEditing_messages: [],
      itemEditing_activeMessage: null
    },
    user: {
      originRoute: null,
      itemEditing: null,
      itemEditing_messages: [],
      itemEditing_activeMessage: null
    },

    // ------------------------------------------------------------------ Driver
    activeDelivery: {
      originRoute: null,
      itemEditing: null,
      itemEditing_messages: [],
      itemEditing_activeMessage: null
    }
  }
}
